export enum YearsOfExperience {
  None = '0',
  OneToTwo = '1-2',
  ThreeToFive = '3-5',
  SixToTen = '6-10',
  GreaterThanTen = '>10',
}

export const YEARS_OF_EXPERIENCE_TRANSLATIONS = {
  [YearsOfExperience.None]: '0 Jahre',
  [YearsOfExperience.GreaterThanTen]: 'Mehr als 10 Jahre',
  [YearsOfExperience.OneToTwo]: '1 bis 2 Jahre',
  [YearsOfExperience.SixToTen]: '6 bis 10 Jahre',
  [YearsOfExperience.ThreeToFive]: '3 bis 5 Jahre',
};
